import Card from "components/common/Card";
import React, { useEffect, useState } from "react";
import BenefitsTabs from "./components/benefitsTabs";
import Button from "components/semantic/Button";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { getSinglePolicy } from "store/thunk/kyp.thunk";
import { useNavigate, useParams } from "react-router-dom";
import BenefitCard from "./components/benefitCard";
import PaymentCard from "./components/PaymentCard";
import { MobileBenefitCardSkeleton, WebBenefitCardSkeleton } from "./components/Skeleton/BenefitCard";

const BenefitSummaryV1 = () => {
  const param: any = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [activeTab, setActiveTab] = useState("hospitalisationBenefits");

  const benefitSummaryList = useAppSelector((state) => state.rootReducer.kypSlice.benefitSummary);
  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.policyData);

  useEffect(() => {
    dispatch(getSinglePolicy(param?.policyId));
  }, [dispatch, param]);

  const handleNavigate = (id: any) => {
    if (!id && activeTab === "hospitalisationBenefits") setActiveTab("otherBenefits");
    else if (!id && activeTab === "otherBenefits") setActiveTab("waitingPeriodAndSubLimits");
    else if (!id && activeTab === "waitingPeriodAndSubLimits") {
      if (benefitSummaryList?.exclusions && benefitSummaryList?.exclusions.length > 0) setActiveTab("exclusions");
      else navigate(`/kyp/kyp-health-result/${param?.policyId}`);
    } else if (!id && activeTab === "exclusions") navigate(`/kyp/kyp-health-result/${param?.policyId}`);
    else setActiveTab(id);
  };

  return (
    <div>
      <h1 className="text-2xl font-extrabold my-3 md:mb-4 text-center">Benefits Summary</h1>

      <Card className="w-full" parentClassName="rounded-md md:rounded-lg border-2 border-gray-300 shadow-none">
        <BenefitsTabs activeTab={activeTab} setActiveTab={setActiveTab} version={benefitSummaryList?.version} benefitSumList={benefitSummaryList} />
      </Card>

      {benefitSummaryList ? (
        <>
          {activeTab == "hospitalisationBenefits" && <BenefitCard id="hospitalisationBenefits" cardData={benefitSummaryList?.hospitalisationBenefits} hasMoratorium={benefitSummaryList?.moratoriumPeriod?.MORATORIUM_PERIOD?.value} />}
          {activeTab == "otherBenefits" && <BenefitCard id="otherBenefits" cardData={benefitSummaryList?.otherBenefits} hasMoratorium={benefitSummaryList?.moratoriumPeriod?.MORATORIUM_PERIOD?.value} />}
          {activeTab == "waitingPeriodAndSubLimits" && <BenefitCard id="waitingPeriodAndSubLimits" cardData={benefitSummaryList?.waitingPeriodAndSubLimits} hasMoratorium={benefitSummaryList?.moratoriumPeriod?.MORATORIUM_PERIOD?.value} />}
          {activeTab == "exclusions" && <BenefitCard id="exclusions" cardData={benefitSummaryList?.exclusions} hasMoratorium={benefitSummaryList?.moratoriumPeriod?.MORATORIUM_PERIOD?.value} />}
          {benefitSummaryList?.moratoriumPeriod?.MORATORIUM_PERIOD?.value && policyData.kypPaymentStatus !== "PENDING" && (
            <div
              className="w-full flex justify-center px-3 py-4 bg-[#EEFFE1] text-[13px] md:text-base font-normal md:font-extrabold border rounded-md md:rounded-lg shadow-none mb-10 text-sm border-l-[5px] border-[#beccb4]"
              dangerouslySetInnerHTML={{
                __html: benefitSummaryList?.moratoriumPeriod?.MORATORIUM_PERIOD?.value || ""
              }}
            />
          )}
        </>
      ) : (
        <>
          <WebBenefitCardSkeleton />
          <MobileBenefitCardSkeleton />
        </>
      )}

      <Card className="w-full hidden md:flex justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none `}>
        <Button title="NEXT" onClick={() => handleNavigate(null)} className={`${!["PAID", "WAIVEOFF"].includes(policyData?.kypPaymentStatus) && "pointer-events-none opacity-50"}`} />
      </Card>

      <Card className="w-full fixed bottom-0 left-0 rounded-t-[15px] bg-white flex md:hidden justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none `}>
        <Button title="NEXT" onClick={() => handleNavigate(null)} className={`${!["PAID", "WAIVEOFF"].includes(policyData?.kypPaymentStatus) && "pointer-events-none opacity-50"}`} />
      </Card>

      {!["PAID", "WAIVEOFF"].includes(policyData?.kypPaymentStatus) && <PaymentCard feeAmount={policyData?.kypFeeAmount} />}
    </div>
  );
};

export default BenefitSummaryV1;
